module.exports = __webpack_public_path__ + "img/1588344054.07d85472.jpg";